import React from 'react';

import { Box, Typography } from '@mui/material';

import { ShowFnOutput } from 'mui-modal-provider';

import { Reservation, ShippingStatus, UserUpdateStatus } from '../../../../graphql/API';
import { useUpdateReservationMutation } from '../../../../pages/ReservationDetail/components/useMutation';
import LoadingButton from '../../../Button/LoadingButton';
import { BaseDialogProps } from '../../Base';

export type CancelReservationProps = {
  reservationDetail?: Reservation;
  modalRef: React.MutableRefObject<ShowFnOutput<BaseDialogProps> | undefined>;
  refetchReservationDetails?: () => void;
};

export const ConfirmShipment: React.FC<CancelReservationProps> = ({
  reservationDetail,
  modalRef,
  refetchReservationDetails,
}) => {
  const cancelReservationMutation = useUpdateReservationMutation({
    onSuccess: () => {
      modalRef.current?.destroy();
      if (refetchReservationDetails) {
        refetchReservationDetails();
      }
    },
  });

  const onCancelHandle = React.useCallback(() => {
    modalRef.current?.destroy();
  }, [modalRef]);

  const onCancelReservationHandle = () => {
    if (reservationDetail?.id) {
      cancelReservationMutation.mutate({
        id: reservationDetail.id,
        shippingStatus: ShippingStatus.shipped,
      });
    }
  };

  return (
    <Box>
      <Typography textAlign={'center'} fontSize={'18px'} fontWeight={500}>
        Confirm the shipment
      </Typography>
      <Typography paddingTop={'34px'} paddingBottom={'44px'} textAlign={'center'}>
        Once you mark the product as shipped, the user will have 14 days to complete the promotion.
      </Typography>

      <Box display={'flex'} alignItems={'center'} gap={'20px'}>
        <LoadingButton
          fullWidth
          variant='outlined'
          size='large'
          sx={{ paddingY: '12px' }}
          onClick={onCancelHandle}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          fullWidth
          loading={cancelReservationMutation.isPending}
          variant='contained'
          type='submit'
          size='large'
          sx={{
            paddingY: '12px',
          }}
          onClick={onCancelReservationHandle}
        >
          Confirm
        </LoadingButton>
      </Box>
    </Box>
  );
};
